import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APPService } from '@service/system/app.service';
import { HttpManager } from '@service/system/httpManager.service';

const APP_URL = APPService.APP_URL;

@Injectable({
  providedIn: 'root'
})
export class EmailValidationService {
  private _emailValidationURL = `${APP_URL}/externaluser`

  constructor(private httpManager: HttpManager) { }

  requestValidationKey(emailAddress: string): Observable<any> {
    return this.httpManager.httpGet<string>(`${this._emailValidationURL}/register`, { 'UserEmail': emailAddress });
  }

  validateEmailByKey(key: string): Observable<any> {
    return this.httpManager.httpGet<string>(`${this._emailValidationURL}/validate`, { 'key': key });
  }
}
